import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    alreadyPublishedArticle: {},
    publisedNotification: {}
};

const PublishedArticleSlice = createSlice({
    name: 'publishedarticles',
    initialState,
    reducers: {
        setPublishedArticleList(state, action) {
            state.alreadyPublishedArticle = action.payload;
        },
        setToast(state, action) {
            state.publisedNotification = action.payload;
        },

    },
});



export const PublishedArticleListApi = (tokendata, page, limit, search) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/publisher/alreadyPublishedArticles?page=${page}&limit=${limit}&search=${search}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setPublishedArticleList(res?.data?.data))
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");
            dispatch(setToast({
                status: false, message: err?.response?.data?.message
            }))

        })

}




export const { setPublishedArticleList, setToast } = PublishedArticleSlice.actions;
const PublishedArticleReducer = PublishedArticleSlice.reducer;

export default PublishedArticleReducer;
